import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "brd-button",
  templateUrl: "./button-wrapper.component.html",
  styleUrl: "./button-wrapper.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ButtonWrapperComponent {
  @Input() text!: string;
  @Input() iconName: string;
  @Input() color: "primary" | "secondary" | "no-border" = "primary";
  @Input() href: string;
  @Input() disabled = false;
  @Output() clickEvent = new EventEmitter<MouseEvent>();

  constructor(private router: Router) { }

  clickAction(event: MouseEvent): void {
    if (this.href && this.href.startsWith("mailto")) window.location.href = this.href;
    else if (this.href) this.router.navigate([this.href]);
    else if (this.clickEvent) this.clickEvent.emit(event);
  }
}
